export const PRODUCT_CHART_COLORS = {
    color1: '#FFAA3A',
    color2: '#FEC75D',
    color3: '#FEDB5D',
    color4: '#D3D3D3'
}
